import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import { addSqlAPI, deleteSqlAPI, getSqlAPI, getSqlDetailAPI, updateSqlAPI } from './api';
import {
  filterSql,
  filterSqlSuccess,
  filterSqlFailure,
  getDetailSql,
  getDetailSqlSuccess,
  getDetailSqlFailure,
  registerSqlSuccess,
  registerSqlFailure,
  registerSql,
  updateSqlSuccess,
  updateSqlFailure,
  deleteSqlSuccess,
  deleteSqlFailure,
  updateSql,
  deleteSql,
} from './slice';
import {
  SearchSearchPatternRequest,
  DetailSearchPatternRequest,
  UpdateSearchPatternRequest,
  DeleteSearchPatternRequest,
} from 'api-types/src/types/search-pattern';

function* fetchSearchPattern({ payload }: { payload: SearchSearchPatternRequest }) {
  try {
    const response: ResponseGenerator = yield call(getSqlAPI, trimQueryData(payload));
    yield put(filterSqlSuccess(response.data));
  } catch (error) {
    yield put(filterSqlFailure());
  }
}

function* fetchSqlDetail({ payload }: { payload: DetailSearchPatternRequest }) {
  try {
    const response: ResponseGenerator = yield call(getSqlDetailAPI, payload);
    yield put(getDetailSqlSuccess(response.data));
  } catch (error: any) {
    yield put(getDetailSqlFailure({ message: error?.message }));
  }
}

function* registerSqlSaga({ payload }: { payload: UpdateSearchPatternRequest }) {
  try {
    const response: ResponseGenerator = yield call(addSqlAPI, payload);
    yield put(registerSqlSuccess(response));
  } catch (error: any) {
    yield put(registerSqlFailure({ message: error?.message }));
  }
}

function* updateSqlSaga({ payload }: { payload: UpdateSearchPatternRequest }) {
  try {
    const response: ResponseGenerator = yield call(updateSqlAPI, payload);
    yield put(updateSqlSuccess(response));
  } catch (error: any) {
    yield put(updateSqlFailure({ message: error?.message }));
  }
}

function* deleteSqlSaga({ payload }: { payload: DeleteSearchPatternRequest }) {
  try {
    const response: ResponseGenerator = yield call(deleteSqlAPI, payload);
    yield put(deleteSqlSuccess(response));
  } catch (error: any) {
    yield put(deleteSqlFailure({ message: error?.message }));
  }
}

function* watchSearchPattern() {
  yield takeLatest(filterSql, fetchSearchPattern);
  yield takeLatest(getDetailSql, fetchSqlDetail);
  yield takeLatest(registerSql, registerSqlSaga);
  yield takeLatest(updateSql, updateSqlSaga);
  yield takeLatest(deleteSql, deleteSqlSaga);
}

export default watchSearchPattern;
